// extracted by mini-css-extract-plugin
export default {"charity":"charity_charity__YCNun","make":"charity_make__85WEv","choose":"charity_choose__ttvXV"};